import React from 'react'

import ScrollContext from 'contexts/ScrollContext';

import { Visibility } from 'semantic-ui-react';

export default class InfiniteScroll extends React.Component {
  componentDidMount() {
    this.setupResizeObserver();
    this.checkAndLoad();
  }

  componentWillUnmount() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.activePage !== this.props.activePage) {
      this.checkAndLoad();
    }
  }

  setupResizeObserver = () => {
    const container = this.getScrollContainer();
    if (!container) return;

    this.resizeObserver = new ResizeObserver(() => {
      this.checkAndLoad();
    });

    this.resizeObserver.observe(container);
  };

  getScrollContainer = () => {

    return this.scrollContext?.current
  };

  checkAndLoad = () => {
    const { onBottomVisible } = this.props;
    const container = this.getScrollContainer();

    if (!container || !onBottomVisible) return;

    if (container.clientHeight >= container.scrollHeight) {
      onBottomVisible();
    }
  };

  onBottomVisible = () => {
    if (this.props.loading) return
    this.props.onBottomVisible()
  }

  render() {
    return(<ScrollContext.Consumer>
      { scrollContext => {
        this.scrollContext = scrollContext

          return (
            <Visibility fireOnMount={false} onBottomVisible={this.onBottomVisible} context={scrollContext.current} continuous={true}>
              {this.props.children}
            </Visibility>
          )
        }
      }
    </ScrollContext.Consumer>)
  }
}
